import {Validators} from "@angular/forms";
import {MarketingBlockFormField} from "../types/base-marketing-block-types";

export const marketingBlockFormFields: Array<MarketingBlockFormField> = [
  {
    fieldName: 'title',
    label: 'Название',
    validators: [ Validators.required ]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий'
  }
]
